import { createSlice } from "@reduxjs/toolkit";
import { CategoryTrees } from "@vviinn/user-managment-client-ts";
import { FetchableState } from "..";
import { fetchCategories } from "./fetch";
import { changeActiveSite } from "../site/site-slice";

type CategoriesState = FetchableState & {
  categories?: CategoryTrees;
};

const initialState: CategoriesState = {
  error: false,
  loading: false,
  status: "idle",
  categories: undefined,
};

const categoriesSlice = createSlice({
  name: "categories",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchCategories.pending, (state) => {
      state.error = false;
      state.loading = true;
      state.status = "loading";
    });

    builder.addCase(fetchCategories.rejected, (state) => {
      state.error = true;
      state.loading = false;
      state.status = "error";
      state.categories = undefined;
    });

    builder.addCase(fetchCategories.fulfilled, (state, { payload }) => {
      state.error = false;
      state.loading = false;
      state.categories = payload;
      state.status = "fulfilled";
    });
    builder.addCase(changeActiveSite, (state) => {
      if (!state.categories) return;
      state.categories = undefined;
      state.status = "idle";
    });
  },
});

export default categoriesSlice.reducer;
